var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bt-button',{class:{ 'button--is-disabled': _vm.loading },on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.loading)?_c('svg',{staticClass:"icon icon--small",domProps:{"innerHTML":_vm._s(require('@/assets/img/loader.svg?inline'))}}):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }